import { Button, Dropdown, Flex, Typography } from 'antd';
import { useState } from 'react';
import { CgMenuLeftAlt } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/img/logo.png';
import { getRoutes } from '../../constants/Routes';
import { isAdmin, isStaff, isSuperAdmin } from '../../helper';
import useAuth from '../../hooks/useAuth';
import { getUser } from '../../redux/actions/auth';
import { handleLogout } from '../../utils';
import ManageUserModal from '../ManageUserModal';
import UserAvatar from '../UserAvatar';
import AsideDrawer from './AsideDrawer';

const Header = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [userData, setUserData] = useState();
  const handleNavigate = () => {
    navigate(getRoutes().manage_users.route());
  };

  const handleUpdateProfile = async () => {
    const res = await getUser({ id: user?.id });
    if (res?.ack) setUserData(res?.user);
  };

  const items = [
    {
      key: 'profile',
      label: (
        <Flex align="center" gap={10}>
          <UserAvatar user={user} style={{ marginRight: 12, fontSize: '20px' }} size="large" />
          <div>
            <Typography.Text strong>{user?.name ?? user?.username}</Typography.Text>
            <br />
            <Typography.Text type="secondary">{user?.email ?? user?.username}</Typography.Text>
          </div>
        </Flex>
      ),
    },
    {
      type: 'divider',
    },
    (isSuperAdmin() || isAdmin()) && {
      key: 'manage-users',
      label: 'Manage Users',
      onClick: handleNavigate,
    },
    {
      key: 'manage_profile',
      label: 'Profile',
      onClick: handleUpdateProfile,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: (
        <Flex justify="center">
          <Button type="link" danger>
            Logout
          </Button>
        </Flex>
      ),
      onClick: handleLogout,
    },
  ];

  const renderBranding = () => {
    return (
      <div className="Header__BrandArea">
        {!isStaff() && (
          <CgMenuLeftAlt className="hamburger" onClick={() => setIsSideBarOpen(!isSideBarOpen)} />
        )}
        <div className="brand-logo">
          <img width={150} src={Logo} alt="Compliance Tracer" onClick={() => navigate('/')} />
        </div>
      </div>
    );
  };

  return (
    <header className="Header">
      {renderBranding()}
      <div className="Header__ProfileArea">
        <Dropdown
          menu={{
            items,
          }}
          trigger={['click']}
        >
          <div>
            <UserAvatar user={user} />
          </div>
        </Dropdown>
      </div>
      {isSideBarOpen && (
        <AsideDrawer
          open={isSideBarOpen}
          onClose={() => setIsSideBarOpen(false)}
          branding={renderBranding()}
        />
      )}
      {userData && (
        <ManageUserModal
          isProfile
          open={userData}
          onCancel={() => setUserData()}
          userData={userData}
        />
      )}
    </header>
  );
};

export default Header;
